// extracted by mini-css-extract-plugin
export default {"App":"App_App__7iJoo","appContent":"App_appContent__lI+Aj","withSideMenu":"App_withSideMenu__BfIQH","withSideMenuExpanded":"App_withSideMenuExpanded__UHTSf"};